export default {"src":"/_next/static/media/chevron-down-v2-icon.c25b0de7.svg","height":6,"width":9,"blurWidth":0,"blurHeight":0};